export default __webpack_public_path__ + "785d1444d0466e7055d05a113a27237f.png";